module.exports = __webpack_public_path__ + "static/Mobile Reg 1-df09a45f61cce038b7f8d239825ff146.png";